import {trackJourney} from '~/utils/journey-client.mjs';

export default defineNuxtPlugin(nuxt => {
  const user = useUser();
  function visit() {
    const route = nuxt.$router.currentRoute.value;
    if (/^\/profiles\/\d+\/gardens(?:\/|$)/.test(route.path)
      && String(route.params.id) === String(user.value?.client_id)) void trackJourney('journal');
  }
  nuxt.hook('app:mounted', visit);
  nuxt.hook('page:finish', visit);
});
